import { render, staticRenderFns } from "./sosMap.vue?vue&type=template&id=b1c6a5fc&scoped=true&"
import script from "./sosMap.vue?vue&type=script&lang=js&"
export * from "./sosMap.vue?vue&type=script&lang=js&"
import style0 from "./sosMap.vue?vue&type=style&index=0&id=b1c6a5fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c6a5fc",
  null
  
)

export default component.exports